(function () {
    'use strict';

    angular
        .module('app')
        .controller('B2bPartnersListController', B2bPartnersListController);

    B2bPartnersListController.$inject = ['API', 'alert', 'debug', '$stateParams', 'ListViewSearchExtension',];

    function B2bPartnersListController(API, alert, debug, $stateParams, ListViewSearchExtension) {
        var vm = this;
        ListViewSearchExtension.extendScope(vm);
        vm.listObject.filter = 'latestFirst';
        vm.loadingState = {
            partnerIsLoading: false
        };
        vm.openRemoveModal = openRemoveModal;
        vm.keyUp = keyUp;
        vm.loadResources = loadResources;


        activate();

        function activate() {
            if ($stateParams.searchObject) {
                vm.loadParams(JSON.parse($stateParams.searchObject));
            }
            loadResources(true);
        }

        function openRemoveModal() {
            alert.confirm('remove-something');
        }

        function loadResources(skipCharacterLimit) {
            var promise = null;

            var searchObject = {
                'page': vm.listObject.page,
                'per-page': vm.listObject.perPage,
            };
            if (vm.listObject.filter) {
                switch (vm.listObject.filter) {
                    case 'latestFirst':
                        searchObject.sort = '-created';
                        break;
                    case 'oldestFirst':
                        searchObject.sort = 'created';
                        break;
                    case 'alphabetAscending':
                        searchObject.sort = '-name';
                        break;
                    case 'alphabetDescending':
                        searchObject.sort = 'name';
                        break;

                    default:
                        break;
                }
            }
            if (vm.listObject.searchTerm && (vm.listObject.searchTerm.length > 2 || skipCharacterLimit)) {
                searchObject.q = vm.listObject.searchTerm;
                promise = API.B2bPartners.search(searchObject).$promise;
            } else if (vm.listObject.searchTerm.length === 0) {
                promise = API.B2bPartners.search(searchObject).$promise;
            }

            vm.onSearch();

            if (promise) {
                vm.loadingState.partnerIsLoading = true;
                promise.then(function (response) {
                    vm.partners = response.items;
                    debug.log(vm.partners);
                    vm.listMeta = response._meta;
                }, function (response) {
                    debug.log(response);
                })
                .finally(function() {
                    vm.loadingState.partnerIsLoading = false;
                });
            }
        }

        function keyUp(event) {
            if (event.keyCode === 13) {
                vm.loadResources(true);
            }
        }
    }
})();